import { Navigate } from 'react-router-dom';
import { useTenant } from '../../context/TenantContext';
import { hasBelts } from '../../utils/publicProfile';

/**
 * Route guard for the belt/grading world (Stage 2 gating). For clubs without belts
 * (gym / yoga / general) the belt routes redirect to the portal dashboard instead of
 * rendering — so a hidden nav item can't be reached by typing the URL. Reversible: the
 * moment a club's type has belts again, the route works. Byte-identical for martial-arts clubs.
 */
export default function BeltGate({ redirectTo, children }) {
  const { club, loading } = useTenant();
  if (loading) return null;                 // wait for club type; avoids a wrong redirect flash
  if (!hasBelts(club?.clubType)) return <Navigate to={redirectTo} replace />;
  return children;
}
